import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";

export default function FeaturedArticles() {
  const { t } = useTranslation();
  const topArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            {t("section_hot_articles")}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            {t("section_hot_articles_desc")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {topArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:bg-background-200/50"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-600 rounded-full whitespace-nowrap">
                  {article.categoryName}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-medium text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-eye-line"></i>
                      </span>
                      {article.readCount > 1000 ? `${(article.readCount / 1000).toFixed(1)}k` : article.readCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-heart-line"></i>
                      </span>
                      {article.likeCount}
                    </span>
                  </div>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}